<div class="generator-container">

    <div class="generator-header">
        <span class="generator-title">{{ translation?.title }}</span>
    </div>

    <div class="generator-chat">
        <abc-chat class="abc-chat" [width]="'100%'" [height]="'100%'" [useDefaultConfig]="false" [showAvatar]="false"
            [activeStateEnabled]="true" [disabled]="false" [focusStateEnabled]="true" [user]="currentUser"
            [dataSource]="chatMessages" [typingUsers]="typingUsers" [messageTemplate]="'chatMessage'"
            (onMessageEntered)="onMessageEntered($event)">

            <div *dxTemplate="let data of 'chatMessage'" [id]="data.message.id" class="chat-message-wrapper"
                [class.is-bot]="isLastAiAssistantMessage(data.message)">
                <div class="message-top-row">
                    <span class="chat-message-text">{{ data.message.text }}</span>

                    <div *ngIf="isLastAiAssistantMessage(data.message) && !generating" class="message-actions">
                        <abc-button [hint]="'Einfügen'" stylingMode="text" icon="clipboardpastesparkle"
                            [hoverStateEnabled]="false" (onClick)="applyGeneratedQuery()">
                        </abc-button>
                    </div>
                </div>
            </div>

        </abc-chat>
    </div>

    <div *ngIf="queryError" class="generator-error">
        <span class="error-text">{{ queryError }}</span>
    </div>
</div>